import React from 'react'

interface TermsOfServiceProps {
  onClose?: () => void
  isModal?: boolean
}

export default function TermsOfService({ onClose, isModal = false }: TermsOfServiceProps) {
  const containerClass = isModal ? 'terms-modal' : 'terms-page'

  return (
    <div className={containerClass} style={{ 
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      backgroundColor: '#1a202c',
      color: '#e2e8f0',
      lineHeight: '1.6',
      padding: '20px',
      minHeight: '100vh'
    }}>
      {isModal && (
        <div className="modal-overlay" onClick={onClose} style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 1000
        }} />
      )}
      
      <div className={`terms-container ${isModal ? 'modal-content' : ''}`} style={{
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: '#2d3748',
        padding: '2rem',
        borderRadius: '12px',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.4)',
        border: '1px solid #4a5568',
        position: isModal ? 'relative' : 'static',
        zIndex: isModal ? 1001 : 'auto'
      }}>
        <div className="terms-header" style={{ marginBottom: '2rem' }}>
          <h1 style={{
            color: '#4cc380',
            fontSize: '2rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            textAlign: 'center'
          }}>Terms of Service for Unbiased Kratom</h1>
          {isModal && (
            <button onClick={onClose} style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              background: 'none',
              border: 'none',
              color: '#e2e8f0',
              fontSize: '1.5rem',
              cursor: 'pointer'
            }}>
              ×
            </button>
          )}
          <div style={{
            textAlign: 'center',
            color: '#a0aec0',
            marginBottom: '2rem',
            fontStyle: 'italic'
          }}>Last Updated: July 10, 2025</div>
        </div>
        
        <div className="terms-content">
          <p style={{ marginBottom: '1rem' }}>
            Welcome to Unbiased Kratom ("we," "us," or "our"), operating the website unbiasedkratom.com (the "Website"). These Terms of Service ("Terms") govern your access to and use of the Website, including any content, features, or services offered, such as the Taper Tracker Pro app. By accessing or using the Website, you agree to be bound by these Terms. If you do not agree, please do not use the Website. These Terms are precautionary and designed to address the future development of the Website.
          </p>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>1. Eligibility</h2>
          <p style={{ marginBottom: '1rem' }}>The Website is intended for users who are 21 years of age or older. By using the Website, you represent and warrant that you are at least 21 years old and have the legal capacity to enter into these Terms. We do not knowingly permit individuals under 21 to use the Website or submit content. If we discover that a user under 21 has accessed the Website or provided information, we may terminate their access and delete their data.</p>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>2. Use of the Website</h2>
          
          <h3 style={{
            color: '#68d391',
            fontSize: '1.1rem',
            marginTop: '1.5rem',
            marginBottom: '0.5rem'
          }}>a. Permitted Use</h3>
          <p style={{ marginBottom: '1rem' }}>You may use the Website to access information about kratom, submit reviews, photos, or other content, and, if applicable, use features like the Taper Tracker Pro app, subject to these Terms. You agree to use the Website only for lawful purposes and in compliance with all applicable federal, state, and local laws, including those of California.</p>
          
          <h3 style={{
            color: '#68d391',
            fontSize: '1.1rem',
            marginTop: '1.5rem',
            marginBottom: '0.5rem'
          }}>b. Prohibited Conduct</h3>
          <p style={{ marginBottom: '1rem' }}>You agree not to:</p>
          <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Use the Website for any illegal or unauthorized purpose.</li>
            <li style={{ marginBottom: '0.5rem' }}>Submit false, misleading, defamatory, or infringing content.</li>
            <li style={{ marginBottom: '0.5rem' }}>Upload content that violates the rights of others, including intellectual property or privacy rights.</li>
            <li style={{ marginBottom: '0.5rem' }}>Attempt to interfere with the Website's functionality, security, or integrity (e.g., hacking, introducing viruses, or overloading servers).</li>
            <li style={{ marginBottom: '0.5rem' }}>Use automated tools (e.g., bots, scrapers) to access or collect data from the Website without our express permission.</li>
            <li style={{ marginBottom: '0.5rem' }}>Impersonate another person or entity or misrepresent your affiliation.</li>
          </ul>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>3. User-Submitted Content</h2>
          
          <h3 style={{
            color: '#68d391',
            fontSize: '1.1rem',
            marginTop: '1.5rem',
            marginBottom: '0.5rem'
          }}>a. Ownership and License</h3>
          <p style={{ marginBottom: '1rem' }}>You retain ownership of any content you submit to the Website, such as photos, reviews, or comments ("User Content"). By submitting User Content, you grant us a non-exclusive, worldwide, royalty-free, perpetual, irrevocable, and sublicensable license to use, display, reproduce, modify, and distribute your User Content on the Website and related platforms for the purpose of operating and promoting the Website. You represent and warrant that you have the right to grant this license and that your User Content does not violate any laws or third-party rights.</p>
          
          <h3 style={{
            color: '#68d391',
            fontSize: '1.1rem',
            marginTop: '1.5rem',
            marginBottom: '0.5rem'
          }}>b. Content Guidelines</h3>
          <p style={{ marginBottom: '1rem' }}>User Content must not:</p>
          <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>Be unlawful, obscene, defamatory, or offensive.</li>
            <li style={{ marginBottom: '0.5rem' }}>Infringe on intellectual property, privacy, or publicity rights.</li>
            <li style={{ marginBottom: '0.5rem' }}>Contain harmful code, such as viruses or malware.</li>
            <li style={{ marginBottom: '0.5rem' }}>Promote or endorse illegal activities or substances.</li>
          </ul>
          <p style={{ marginBottom: '1rem' }}>We reserve the right to review, moderate, or remove User Content at our discretion, including content that violates these Terms or is deemed inappropriate.</p>
          
          <h3 style={{
            color: '#68d391',
            fontSize: '1.1rem',
            marginTop: '1.5rem',
            marginBottom: '0.5rem'
          }}>c. Taper Tracker Pro App Data</h3>
          <p style={{ marginBottom: '1rem' }}>Data and photos submitted through the Taper Tracker Pro app, if applicable, will be used solely for the app's functionality and will not be shared with third parties, except as required by law. This data is subject to the same content guidelines and ownership terms as other User Content but is protected under our Privacy Policy's specific provisions for the app.</p>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>4. Intellectual Property</h2>
          <p style={{ marginBottom: '1rem' }}>All content on the Website, excluding User Content, including text, graphics, logos, and software, is owned by Unbiased Kratom or its licensors and is protected by U.S. copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, or create derivative works from this content without our express written permission, except as permitted by law (e.g., fair use).</p>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>5. Taper Tracker Pro App</h2>
          <p style={{ marginBottom: '1rem' }}>If you use the Taper Tracker Pro app, you agree to use it solely for personal, non-commercial purposes related to tracking kratom use or related activities. The app is provided "as is," and we do not guarantee its accuracy, completeness, or suitability for your needs. Data entered into the app is subject to our Privacy Policy, which ensures that it will not be shared except as required by law.</p>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>6. Third-Party Links and Services</h2>
          <p style={{ marginBottom: '1rem' }}>The Website may contain links to third-party websites, services, or resources. We are not responsible for the content, availability, or practices of these third parties. Your use of third-party services is at your own risk, and we encourage you to review their terms and privacy policies.</p>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>7. Disclaimers</h2>
          <p style={{ marginBottom: '1rem' }}>The Website and its content, including the Taper Tracker Pro app, are provided "as is" without warranties of any kind, whether express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement. We do not guarantee that the Website will be uninterrupted, error-free, or secure, or that the information provided is accurate or complete. You use the Website at your own risk.</p>
          <p style={{ marginBottom: '1rem' }}>Kratom-related information on the Website is for informational purposes only and is not medical, legal, or professional advice. Consult a qualified professional before making decisions based on this information.</p>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>8. Limitation of Liability</h2>
          <p style={{ marginBottom: '1rem' }}>To the fullest extent permitted by law, Unbiased Kratom, its affiliates, officers, directors, employees, and agents will not be liable for any indirect, incidental, consequential, special, or punitive damages arising from your use of the Website or Taper Tracker Pro app, including but not limited to damages for loss of data, profits, or use. Our total liability for any claim related to the Website will not exceed $100. This limitation applies regardless of the legal theory (e.g., contract, tort, or statute) and even if we have been advised of the possibility of such damages.</p>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>9. Indemnification</h2>
          <p style={{ marginBottom: '1rem' }}>You agree to indemnify, defend, and hold harmless Unbiased Kratom, its affiliates, officers, directors, employees, and agents from any claims, liabilities, damages, or expenses (including reasonable attorneys' fees) arising from your use of the Website, your User Content, or your violation of these Terms or applicable law.</p>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>10. Termination</h2>
          <p style={{ marginBottom: '1rem' }}>We may suspend or terminate your access to the Website or Taper Tracker Pro app at our discretion, with or without notice, for any reason, including if we believe you have violated these Terms. Upon termination, your right to access the Website will cease, but any User Content you submitted may remain on the Website unless you request its removal, subject to our Privacy Policy.</p>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>11. Governing Law and Dispute Resolution</h2>
          <p style={{ marginBottom: '1rem' }}>These Terms are governed by the laws of the State of California and applicable U.S. federal law, without regard to conflict of law principles. Any disputes arising from these Terms or your use of the Website will be resolved through binding arbitration in California, conducted under the rules of the American Arbitration Association, except that either party may seek injunctive relief in a court of competent jurisdiction for claims related to intellectual property or confidentiality. You waive any right to participate in a class action lawsuit or class-wide arbitration.</p>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>12. Changes to These Terms</h2>
          <p style={{ marginBottom: '1rem' }}>We may update these Terms to reflect changes in our practices or legal requirements. We will notify you of material changes by posting the updated Terms on the Website or, where required, by direct communication. The "Last Updated" date at the top indicates when the Terms were last revised. Your continued use of the Website after changes constitutes acceptance of the updated Terms.</p>

          <h2 style={{
            color: '#4cc380',
            fontSize: '1.3rem',
            marginTop: '2rem',
            marginBottom: '1rem'
          }}>13. Contact Us</h2>
          <p style={{ marginBottom: '1rem' }}>If you have questions or concerns about these Terms, please contact us at:</p>
          <div style={{
            backgroundColor: '#1a202c',
            padding: '1rem',
            borderRadius: '8px',
            marginTop: '1rem',
            borderLeft: '4px solid #4cc380'
          }}>
            <strong style={{ color: '#fff' }}>Unbiased Kratom</strong><br />
            unbiasedkratom@gmail.com
          </div>
        </div>
      </div>
    </div>
  )
}